// vendor
import DialogBase from "@material-ui/core/Dialog";
import withStyles from "@material-ui/core/styles/withStyles";
// component
import * as React from "react";
import AlertModalLayout, { IProps as IAlertModalLayout } from "./alert";

const Dialog = withStyles({
  root: {
    zIndex: "1400 !important" as any,
  },
  paper: {
    overflowY: "hidden",
    // NOTE: Theme 에서 백그라운드 색을 불러올 수 없음.
    backgroundColor: "#131313",
  },
})(DialogBase);

interface IProps extends IAlertModalLayout {
  open: boolean;
  onClose: () => void;
}

const AlertDialog = ({ open, onClose, ...props }: IProps) => (
  <Dialog open={open} onClose={onClose}>
    <AlertModalLayout {...props} />
  </Dialog>
);

export default React.memo(AlertDialog);
